import { connect } from 'react-redux'
import { compose, withHandlers } from 'recompose'
import { hideFilterModal } from 'actions/filterModal'
import { getTiresFilterData, getTiresSelectedFilters } from '../../selectors'
import { resetFilters, applyFilter } from '../../actions'
import GlobalSearchFilterModal from './GlobalSearchFilterModal'

const withGlobalSearchFilterModalHandlers = withHandlers({
  handleSubmit: ({ hideFilterModal }) => () =>
    hideFilterModal(),

  handleFilterClear: ({ resetFilters }) => (...args) =>
    resetFilters(...args),

  handleFilterRemove: ({ applyFilter }) => (...args) =>
    applyFilter(...args),

  handleFilterChange: ({ applyFilter }) => (...args) =>
    applyFilter(...args)
})

const mapStateToProps = state => ({
  filters: getTiresFilterData(state),
  selectedFilters: getTiresSelectedFilters(state)
})

export default compose(
  connect(mapStateToProps, { resetFilters, applyFilter, hideFilterModal }),
  withGlobalSearchFilterModalHandlers
)(GlobalSearchFilterModal)
